/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GammaProductBaseDto } from '../models/GammaProductBaseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductService {
    /**
     * @param id
     * @param sizes
     * @param colors
     * @param brands
     * @param categories
     * @param fromPrice
     * @param toPrice
     * @param pageIndex
     * @param pageSize
     * @param withVariants
     * @param search
     * @returns any
     * @throws ApiError
     */
    public static searchProductController(
        id?: number,
        sizes?: Array<string>,
        colors?: Array<string>,
        brands?: Array<number>,
        categories?: Array<number>,
        fromPrice?: number,
        toPrice?: number,
        pageIndex?: number,
        pageSize?: number,
        withVariants?: boolean,
        search?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products/search',
            query: {
                'id': id,
                'sizes': sizes,
                'colors': colors,
                'brands': brands,
                'categories': categories,
                'fromPrice': fromPrice,
                'toPrice': toPrice,
                'pageIndex': pageIndex,
                'pageSize': pageSize,
                'withVariants': withVariants,
                'search': search,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static checkExistsProductController(
        requestBody: {
            path?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/products/check-exists',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param formData
     * @returns any
     * @throws ApiError
     */
    public static uploadProductController(
        formData: {
            file?: Blob;
            path?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/products/media',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @param formData
     * @returns any
     * @throws ApiError
     */
    public static setMediaProductController(
        id: number,
        formData: {
            file?: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/products/{id}/media',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static deleteMediaProductController(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/products/{id}/media',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any Product synchronized with Gamma
     * @throws ApiError
     */
    public static syncGammaProductProductController(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        updatedProducts?: Array<GammaProductBaseDto>;
        updatedStocks?: Array<{
            itemCode?: string;
            itemCodeVariant?: string;
            availability?: number;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/products/sync-gamma/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param filters
     * @param sorting
     * @param fields
     * @param includes
     * @param deleted
     * @returns any
     * @throws ApiError
     */
    public static findAllProductController(
        page?: number,
        pageSize?: number,
        filters?: string,
        sorting?: string,
        fields?: string,
        includes?: string,
        deleted?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products',
            query: {
                'page': page,
                'pageSize': pageSize,
                'filters': filters,
                'sorting': sorting,
                'fields': fields,
                'includes': includes,
                'deleted': deleted,
            },
        });
    }
    /**
     * @param id
     * @param fields
     * @param includes
     * @param deleted
     * @returns any
     * @throws ApiError
     */
    public static findOneProductController(
        id: any,
        fields?: string,
        includes?: string,
        deleted?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products/{id}',
            path: {
                'id': id,
            },
            query: {
                'fields': fields,
                'includes': includes,
                'deleted': deleted,
            },
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param filters
     * @param sorting
     * @param fields
     * @param includes
     * @param deleted
     * @returns any
     * @throws ApiError
     */
    public static countProductController(
        page?: number,
        pageSize?: number,
        filters?: string,
        sorting?: string,
        fields?: string,
        includes?: string,
        deleted?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products/count',
            query: {
                'page': page,
                'pageSize': pageSize,
                'filters': filters,
                'sorting': sorting,
                'fields': fields,
                'includes': includes,
                'deleted': deleted,
            },
        });
    }
}
